import { useCallback } from 'react';
import { useHttpClient } from '../../contexts';

export type ProposalShareLinkMedium = 'sms' | 'email' | 'share' | 'copy';

interface ProposalShareLinkUtm {
  medium: ProposalShareLinkMedium;
  campaign: 'followup';
}

const UTM_SOURCE = 'ca_device';

export const appendUtmParams = (url: string, utm: ProposalShareLinkUtm) => {
  const shareLink = new URL(url);

  shareLink.searchParams.set('utm_source', UTM_SOURCE);
  shareLink.searchParams.set('utm_medium', utm.medium);
  shareLink.searchParams.set('utm_campaign', utm.campaign);

  return shareLink.toString();
};

export const useProposalShareLinkRequest = () => {
  const httpClient = useHttpClient();

  return useCallback(
    (
      appointmentId: string,
      appointmentProposalId: string,
      customerInfo: { name: string; appointmentProposalOptionId?: string },
      options?: { signal?: AbortSignal }
    ) =>
      httpClient.post<{ url: string }>(
        [
          '/proposal-presentations',
          appointmentProposalId,
          'generate-link',
        ].join('/'),
        customerInfo,
        { params: { appointmentId }, signal: options?.signal }
      ),
    [httpClient]
  );
};
